import { Form } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';

import { useTrackEvent } from '@/App/Blotter/useTrackEvent.ts';
import { useAlgoTileId, useValidateAlgo } from '@/App/tiles/orders/AlgoOrders/AlgoContext.tsx';
import { OrderRow } from '@/App/tiles/orders/components/OrderRow.tsx';
import { OmsFieldErrorWrapper } from '@/components/ui/OmsFieldErrorWrapper.tsx';
import { useAppSelector } from '@/store/hooks.ts';
import { selectAlgoErrors, selectAlgoSpeed } from '@/store/orders/algoOrders/selectors.ts';
import { type Speed, speeds } from '@/store/orders/algoOrders/state.ts';

export const AlgoSpeed = () => {
  const tileId = useAlgoTileId();
  const track = useTrackEvent();

  const speed = useAppSelector((state) => selectAlgoSpeed(state, tileId));

  const validateAlgo = useValidateAlgo();

  const errors = useAppSelector((state) => selectAlgoErrors(state, tileId));
  const speedError = errors?.speed;

  const handleChangeSpeed = (event: React.ChangeEvent<HTMLSelectElement>) => {
    track('Order action', 'Speed changed');
    const newSpeed = event.target.value as Speed;

    validateAlgo({
      speed: newSpeed,
    });
  };

  return (
    <OrderRow labelId="order.fields.speed">
      <OmsFieldErrorWrapper errors={speedError}>
        <Form.Select value={speed} onChange={handleChangeSpeed} size="sm" data-e2e="speed-selector">
          {speeds.map((speed) => (
            <option key={speed} value={speed}>
              <FormattedMessage id={`order.fields.speed.${speed}`} />
            </option>
          ))}
        </Form.Select>
      </OmsFieldErrorWrapper>
    </OrderRow>
  );
};
